import type { EmployeeAlertDuplicateCompanyContracts } from '@/common/graphql';

export const DetailDescriptionEmployeeAlertDuplicateCompanyContracts = ({
  reason,
}: {
  reason: Pick<EmployeeAlertDuplicateCompanyContracts, 'conflictingCompanyNames'>;
}) => (
  <div>
    Conflicting companies:&nbsp;
    {reason.conflictingCompanyNames.join(', ')}
  </div>
);
